const ELEMENTS = [
  {
    selector: '.c-room-header__location',
    name: 'address',
  },
  {
    selector: 'h1.room__name',
    name: 'room_name',
  },
];

function getSelection() {
  if (window.getSelection) {
    return window.getSelection().toString();
  }

  if (document.selection && document.selection.type !== 'Control') {
    return document.selection.createRange().text;
  }
  return '';
}

function track(elementName, value, interaction) {
  $.publish('room_page_interaction', {
    section: 'summary',
    element: elementName,
    element_value: value.slice(0, 100),
    interaction,
  });
}

$('.c-venue-feature-active').on('click', (e) => {
  e.preventDefault();
  const $target = $(e.currentTarget);
  const href = $target.attr('href');

  // scroll to the element
  const $element = $(href);
  if ($element.length > 0) {
    $element[0].scrollIntoView({ behavior: 'smooth' });
  }
});

ELEMENTS.forEach(({ selector, name }) => {
  const element = document.querySelector(selector);

  if (!element) {
    return;
  }

  element.addEventListener('mouseup', () => {
    const selectedText = getSelection();

    if (selectedText.length === 0) {
      return;
    }

    track(name, selectedText, 'select');
  });

  element.addEventListener('copy', () => {
    const selectedText = getSelection();

    if (selectedText.length === 0) {
      return;
    }

    track(name, selectedText, 'copy');
  });
});
